import React from "react";
import HeaderComponent from "./HeaderComponent";
import FooterComponent from "./FooterComponent";
import SidebarComponent from "./SidebarComponent";

const AfterLoginMenuComponent = (props) => {
  const { shouldRender } = props;

  return !shouldRender ? (
    <></>
  ) : (
    <>
      <HeaderComponent />
    </>
  );
};

export default AfterLoginMenuComponent;
